export default __webpack_public_path__ + "static/media/remeet-image-3.7dcdbc0c.png";